import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import { formatDate } from '@helpers'
import React from 'react'
import { useSalonContext } from '../../context'

export default function SalonTimeline() {
    const { salon } = useSalonContext()

    if (salon.state.status === "unavailable")
        return null

    return (
        <Grid gap="10px">
            <Grid gap="0px">
                <small>Timeline</small>
                <hr />
            </Grid>
            <Grid gap="30px" columns="3">
                <EmphasizedContent style={{ opacity: salon.attrs.participations().length > 0 ? .6 : 1 }}>
                    <Grid gap="5px">
                        <small>Step 1</small>
                        {salon.attrs.participations().length > 0 
                            ? <h4>✓ Uploaded the entry</h4> 
                            : <h4>Upload an entry</h4>}
                        {salon.attrs.participations().length > 0 
                            ? <small>{`Done. You uploaded ${salon.attrs.participations().length} from ${salon.state.entry.length * 4} images.`}</small>
                            : <small>{`You can upload up to ${salon.state.entry.length * 4} images until the salon is closing entries, ${formatDate(salon.state.closing_date)}.`}</small>}
                    </Grid>
                </EmphasizedContent>
                <EmphasizedContent style={{ opacity: salon.state.is_paid ? .6 : 1 }}>
                    <Grid gap="5px">
                        <small>Step 2</small>
                        {salon.state.is_paid 
                            ? <h4>✓ Paid the fee</h4> 
                            : <h4>Pay the fee</h4>}
                        {salon.state.is_paid 
                            ? <small>{`Done. You paid the entry fee.`}</small> 
                            : <small>{`The entry fee (€${salon.state.fee}) is required for participation. You can pay until ${formatDate(salon.state.closing_date)}.`}</small>}
                    </Grid>
                </EmphasizedContent>
                <EmphasizedContent style={{ opacity: salon.state.type === "finished" ? .6 : 1 }}>
                    <Grid gap="5px">
                        <small>Step 3</small>
                        {salon.state.type === "finished" 
                            ? <h4>✓ Results</h4> 
                            : <h4>Wait for results</h4>}
                        {salon.state.type === "finished" 
                            ? <small>{`Done. Results available.`}</small>
                            : <small>{`The results will be available around ${formatDate(salon.state.results_date)}. We'll send a notification to your email when they're ready.`}</small>}
                    </Grid>
                </EmphasizedContent>
            </Grid>
        </Grid>
    )
}